import { useEffect, useState } from 'react';
import { convertToFinalPrice } from '../../finalPrice';
import { formatMoney } from '../../utils';
import { TicketSellingRangeChip } from '../../pages/activitycards/components/TicketBlock';
import { filterTicketsBySellingRange } from '../../utils/ticketHelper';
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import { TicketIcon } from '../../icons';

const parseTimeslot = (timeslotStr = '') => {
    const [start, end] = timeslotStr.split(',');
    return { start_time: start, end_time: end };
};

const SingleAgentCommissionTable = ({
    activity,
    selectedTimeslot,
    timeslots,
    showTicketSellingRanges = false
}) => {
    const [tickets, setTickets] = useState(activity?.tickets || []);

    const timeslot =
        typeof selectedTimeslot === 'string'
            ? parseTimeslot(selectedTimeslot)
            : timeslots && timeslots.length > 0
            ? { start_time: timeslots[0].start_time, end_time: timeslots[0].end_time }
            : { start_time: null, end_time: null };

    const perTicket = {};

    timeslots
        .filter(e => e.start_time === timeslot.start_time && e.end_time === timeslot.end_time)
        .forEach(e => {
            perTicket[e.ticket_id] = e;
        });

    useEffect(() => {
        if (showTicketSellingRanges) {
            setTickets(
                filterTicketsBySellingRange(
                    activity?.tickets,
                    timeslot.start_time,
                    timeslot.end_time
                )
            );
        } else {
            setTickets(activity?.tickets || []);
        }
    }, [activity?.tickets, timeslot?.start_time, timeslot?.end_time, showTicketSellingRanges]);

    if (!timeslot.start_time || !timeslot.end_time) {
        return <Typography>No timeslot available!</Typography>;
    }

    return (
        <List disablePadding>
            {tickets?.length > 0 ? (
                tickets.map((ticket, idx) => {
                    const timeslotTicket = perTicket[ticket.id];
                    if (!timeslotTicket) {
                        return null;
                    }
                    return (
                        <ListItem key={idx} divider>
                            <ListItemIcon
                                style={{
                                    width: 25,
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <TicketIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <Typography fontWeight="bold">
                                            {timeslotTicket.name}
                                        </Typography>
                                        {formatMoney(
                                            convertToFinalPrice(
                                                timeslotTicket.retail_price,
                                                timeslotTicket?.final_price
                                            )
                                        )}
                                        {!showTicketSellingRanges && (
                                            <TicketSellingRangeChip
                                                ticket={ticket}
                                                showTicketSellingRanges={showTicketSellingRanges}
                                            />
                                        )}
                                    </Box>
                                }
                                secondary={
                                    <Typography variant="caption">
                                        Commission: {formatMoney(timeslotTicket.agentCommission)}
                                    </Typography>
                                }
                            />
                        </ListItem>
                    );
                })
            ) : (
                <Typography style={{ paddingLeft: 16 }}>No tickets available</Typography>
            )}
        </List>
    );
};

export default SingleAgentCommissionTable;
